'use client';
import { createUnitParser } from '../../../modules/units/impl/createUnitParser/createUnitParser.js';

const lookup = {
    round: ()=>'200px'
};
const borderRadius = ({ unitBorderRadius })=>{
    return createUnitParser({
        suffix: 'r',
        lookup,
        parseUnit: (value)=>{
            if (value == null) {
                return `${unitBorderRadius}px`;
            }
            return `${unitBorderRadius * Number(value)}px`;
        }
    });
};

export { borderRadius };
//# sourceMappingURL=borderRadius.js.map
